import React from "react";
import { map } from "lodash";
import styles from "./charts.module.scss";

export interface TooltipRow {
  label: string;
  value: string;
  color?: string;
}

interface Props {
  title: string;
  rows: TooltipRow[];
}

function TooltipBox({ title, rows }: Props) {
  return (
    <div className={styles.tooltip}>
      <div className={styles.tooltipTitle}>{title}</div>
      {map(rows, ({ label, value, color }) => (
        <div key={label} className={styles.tooltipRow}>
          <span className={styles.tooltipLabel}>
            {color && <i className={styles.tooltipSwatch} style={{ backgroundColor: color }} />}
            {label}
          </span>
          <span className={styles.tooltipValue}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default TooltipBox;
